import React,{Component} from 'react';
import "./style.less";
import {getRefundPrice,refund} from "../../../service/shiftService";
import {connect} from "react-redux";
import {NavBar, TextareaItem,Toast,InputItem} from "antd-mobile";
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class RefundTicket extends Component{
    constructor(props) {
        console.log(props)
        super(props);
        this.state = {
           charge:'',
           notes:'',
        };
    }
    componentDidMount(){
        this.getRefundPrice();
     }
     getRefundPrice = () => {
        let params = {
            "token": this.props.userInfo.token,
            "data":{
                "id": this.props.history.location.state.id
            }
          }
          console.log(params)
          Toast.loading("正在加载",0);
          getRefundPrice(params)
            .then((res) => {
                console.log(res)
                if (res.data.code === '0000') {
                    Toast.hide();
                    this.setState({
                        charge:res.data.data.charge
                    })
                }
                else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                }
                else {
                    this.setState({ changeShiftData:[]})
                    Toast.info(res.data.msg);
                }
            }).catch(function (error) {
              console.log(error);
          });
    }
    infoChange=(v,key)=>{
        this.setState({
            [key]:v
        })
    }
    //确认退票
    sureRefund = () => {
        let params = {
            "token": this.props.userInfo.token,
            "data":{
                "id": this.props.history.location.state.id,
                "charge":this.state.charge,
                "userType":1,
                "notes":this.state.notes
            }
          }
        console.log(params)
        Toast.loading("正在加载",0);
        refund(params)
            .then((res) => {
                console.log(res)
                if (res.data.code === '0000') {
                    Toast.hide();
                    //有四个地方可以跳转到退票页面，一是乘客详情，2是出行位置详情，3是代下单记录，4是代下单记录详情,乘客详情需要返回两个页面，
                    if(this.props.history.location.state.refundType == 1){
                        Toast.info('退票成功',2,this.props.history.go(-2));
                    }
                    else {
                        Toast.info('退票成功',2,this.props.history.go(-1));
                    }
               
                
                }
                else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                }
                else {

                    this.setState({ changeShiftData:[]})
                    Toast.info(res.data.msg);
                }
            }).catch(function (error) {
            console.log(error);
        });
    }
    render(){
        return(
            <div className="refundTicket">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()} />}
                >退票</NavBar>
                <div className="content">
                    <div className="top">
                        <div className="tit">费用明细</div>
                        <div className="info">
                        <InputItem 
                        placeholder="输入更改的手续费" 
                        value={this.state.charge}
                        extra="¥"
                        onChange={(val) => this.infoChange(val, 'charge')}
                    ><span>手续费</span></InputItem>
                        </div>
                    </div>
                    <div className="middle">
                        <div className="tit">特殊情况说明</div>
                        <TextareaItem
                            placeholder="输入内容"
                            rows={5}
                            onChange={(val) => this.infoChange(val, 'notes')}
                            value={this.state.notes}
                        />
                    </div>
                    <div className="text">
                        <p>如果手续费发生变更，请填写特殊情况说明</p>
                        <p>手续费发生变更后进入审核环节，如情况不属实则取消变更</p>
                    </div>
                    <button onClick={()=>this.sureRefund()}>确认退票</button>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/RefundTicket/index.js